import { Stack, Divider } from '@mantine/core';
import { Organization, OrganizationContact } from '@medplum/fhirtypes';
import { ReactElement } from 'react';
import { useMedplum } from '@medplum/react';
import { PartnerAboutSection } from './PartnerAboutSection';
import { PartnerContactsSection } from './PartnerContactsSection';
import { partnerRoles } from '@bariendo/lib/partner-markets';
import { PartnerMarketsSection } from './PartnerMarketsSection';

type PartnerTimelineSummaryProps = {
  organization: Organization;
  onOrganizationChange: (org: Organization) => void;
};

export function PartnerTimelineSummary({
  organization,
  onOrganizationChange,
}: PartnerTimelineSummaryProps): ReactElement {
  const medplum = useMedplum();

  return (
    <Stack gap="xs" p="xs">
      {/* Partner About Section */}
      <PartnerAboutSection
        organization={organization}
        onChange={async (org) => {
          const updatedOrg = await medplum.updateResource(org);
          onOrganizationChange(updatedOrg);
        }}
      />

      <Divider />

      {partnerRoles(organization).length > 0 && (
        <>
          <PartnerMarketsSection organization={organization} />
          <Divider />
        </>
      )}

      {/* Partner Contacts Section */}
      <PartnerContactsSection
        contacts={organization?.contact || []}
        onChange={async (updatedContacts) => {
          const updatedOrg = await medplum.updateResource({
            ...organization,
            contact: updatedContacts,
          });
          onOrganizationChange(updatedOrg);
        }}
        onAdd={async (newContact: OrganizationContact) => {
          const updatedOrg = await medplum.updateResource({
            ...organization,
            contact: [...(organization.contact || []), newContact],
          });
          onOrganizationChange(updatedOrg);
        }}
      />
    </Stack>
  );
}
